import React from 'react';
import css from './GuestCountSelector.module.css';

const GuestCountSelector = ({
  adultCount,
  childrenCount,
  onIncrementAdult,
  onDecrementAdult,
  onIncrementChildren,
  onDecrementChildren,
  maxGuest,
  intl,
}) => {
  const max = parseInt(maxGuest, 10) || 1;
  const total = adultCount + childrenCount;

  const adultAtMin = adultCount <= 1;
  const childrenAtMin = childrenCount <= 0;
  const atMax = total >= max;

  return (
    <div className={css.root}>
      <div className={css.row}>
        <div className={css.labelGroup}>
          <span className={css.label}>
            {intl.formatMessage({ id: 'GuestCountSelector.adultsLabel' })}
          </span>
          <span className={css.subNote}>
            {intl.formatMessage({ id: 'GuestCountSelector.adultsNote' })}
          </span>
        </div>
        <div className={css.counter}>
          <button
            type="button"
            className={css.btn}
            onClick={onDecrementAdult}
            disabled={adultAtMin}
            aria-label={intl.formatMessage({ id: 'GuestCountSelector.removeAdult' })}
          >
            −
          </button>
          <span className={css.count}>{adultCount}</span>
          <button
            type="button"
            className={css.btn}
            onClick={onIncrementAdult}
            disabled={atMax}
            aria-label={intl.formatMessage({ id: 'GuestCountSelector.addAdult' })}
          >
            +
          </button>
        </div>
      </div>

      <div className={css.row}>
        <div className={css.labelGroup}>
          <span className={css.label}>
            {intl.formatMessage({ id: 'GuestCountSelector.childrenLabel' })}
          </span>
          <span className={css.subNote}>
            {intl.formatMessage({ id: 'GuestCountSelector.childrenNote' })}
          </span>
        </div>
        <div className={css.counter}>
          <button
            type="button"
            className={css.btn}
            onClick={onDecrementChildren}
            disabled={childrenAtMin}
            aria-label={intl.formatMessage({ id: 'GuestCountSelector.removeChild' })}
          >
            −
          </button>
          <span className={css.count}>{childrenCount}</span>
          <button
            type="button"
            className={css.btn}
            onClick={onIncrementChildren}
            disabled={atMax}
            aria-label={intl.formatMessage({ id: 'GuestCountSelector.addChild' })}
          >
            +
          </button>
        </div>
      </div>

      <div className={css.maxNote}>
        {intl.formatMessage({ id: 'GuestCountSelector.maxNote' }, { max })}
      </div>
    </div>
  );
};

export default GuestCountSelector;
